export default "__VITE_ASSET__MZ6XyamU__"